import ThreatTypeSelector from './ThreatTypeSelectorContainer';

export default ThreatTypeSelector

